<div class="layout-sidebar">
        <app-menu [model]="model"></app-menu>
</div>